import { ReportPositionOptionFragment } from "../../../../graphql";

export const doesPositionHaveJobPosting = (
  position: ReportPositionOptionFragment
): boolean => {
  return position.hasJobPostingDescription;
};

export const MAX_SKILL_COUNT = 25;
